import "./style.css";
import React, { useState, useEffect } from "react";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

export default function InputAHSF(props) {
  const JsonDataa = useSelector((state) => state.FetchDataJson);
  const lang = useSelector((state) => state.languageReducer.Language);

  console.log(JsonDataa, "sssssssssdwdwd");
  const [arabicError, setArabicError] = useState(false);
  const [englishError, setEnglishError] = useState(false);
  const [numberError, setNumberError] = useState(false); // ✅ new

  const [inputValue, setInputValue] = useState(
    props.value !== undefined && props.value !== ""
      ? props.value
      : props.defaultValue || ""
  );
  useEffect(() => {
    if (props.clear) {
      setInputValue(""); // clear the input value if clear prop is true
    }
  }, [props.clear]);

  // Synchronize the input value when the `value` prop changes
  useEffect(() => {
    if (props.value !== undefined && props.value !== "") {
      setInputValue(props.value);
    }
  }, [props.value]);

  const addCommas = (num) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Modified to preserve decimal points
  const removeNonNumeric = (num) => num.toString().replace(/[^0-9.]/g, "");

  // Handle multiple decimal points (keep only the first one)
  const normalizeDecimal = (num) => {
    const parts = num.split(".");
    return parts[0] + (parts.length > 1 ? "." + parts.slice(1).join("") : "");
  };

  const handleChange = (e) => {
    let fieldsName = props.fieldsName;
    let code = JsonDataa?.JsonData[props.fieldsName]?.[fieldsName];
    let wordsNumber = code ? code.wordsNumber : 300;

    const value = e.target.value;

    if (props.type === "arabic") {
      const arabicRegex = /^[\u0600-\u06FF\u0660-\u0669 0-9\s.,!?;:'"-()،؟]*$/;

      if (!arabicRegex.test(value)) {
        setArabicError(true);
      } else {
        setArabicError(false);
      }

      setInputValue(value);
      if (props.onChange)
        props.onChange({ ...e, target: { ...e.target, value } });
      return;
    }

    if (props.type === "english") {
      const englishRegex = /^[A-Za-z0-9\s.,!?;:'"-()]*$/;

      if (!englishRegex.test(value)) {
        setEnglishError(true);
      } else {
        setEnglishError(false);
      }

      setInputValue(value);
      if (props.onChange)
        props.onChange({ ...e, target: { ...e.target, value } });
      return;
    }

    if (props.type === "number") {
      const numberRegex = /^[0-9]*\.?[0-9]*$/; // digits + optional one decimal point
      if (!numberRegex.test(value)) {
        setNumberError(true);
      } else {
        setNumberError(false);
      }

      setInputValue(value);
      if (props.onChange)
        props.onChange({ ...e, target: { ...e.target, value } });
      return;
    }

    if (props.type === "rate") {
      const ratePattern = /^(100|[1-9]?[0-9])$/;
      const isEmpty = value === "";

      if (ratePattern.test(value) || isEmpty) {
        setInputValue(value);
        if (props.onChange)
          props.onChange({
            ...e,
            target: { ...e.target, value: value },
          });
      }
      return;
    }

    const wordsArray = value;
    // .trim().split(/\s+/);
    if (props.comma === true) {
      const cleanValue = removeNonNumeric(e.target.value);
      const normalizedValue = normalizeDecimal(cleanValue);

      // Handle decimal numbers correctly
      const parts = normalizedValue.split(".");
      const integerPart = addCommas(parts[0]);
      const decimalPart = parts.length > 1 ? "." + parts[1] : "";

      e.target.value = normalizedValue;
      setInputValue(integerPart + decimalPart);

      if (props.onChange) {
        props.onChange(e);
      }
    } else {
      if (wordsArray.length <= wordsNumber) {
        setInputValue(value);

        if (props.onChange) {
          if (props.MaxNumber) {
            if (
              parseInt(e.target.value) <= 10 &&
              parseInt(e.target.value) >= 1
            ) {
              props.onChange(e);
            } else {
              setInputValue("");
            }
          } else {
            props.onChange(e);
          }
        }
      }
    }
  };
  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  console.log(JsonDataa, "JsonDataa");

  return JsonDataa ? (
    <>
      {props.show && (
        <div className="containerInputAHSF" id={props.labelId}>
          <div className="label-container">
            {!props.hidelable ? (
              <label
                id={props.labelId}
                className="labeInput "
                for={JsonDataa?.JsonData[props?.fieldsName]?.code}
                title={
                  props.lang == "ar"
                    ? JsonDataa?.JsonData[props.fieldsName]?.nameEN
                    : JsonDataa?.JsonData[props.fieldsName]?.nameAR
                }
                style={{
                  textAlign: props.lang !== "en" ? "right" : "left",
                  fontFamily:
                    props.font === "en" ? "Ge2ss, sans-serif" : undefined,
                }}
              >
                {props.lang !== "en"
                  ? JsonDataa?.JsonData[props.fieldsName]?.nameAR
                  : JsonDataa?.JsonData[props.fieldsName]?.nameEN}
                {JsonDataa?.JsonData[props.fieldsName]?.isRequired &&
                  !props.showAsterisk && <span>*</span>}
              </label>
            ) : (
              ""
            )}
            {props.showValidationMessage && (
              <span
                className="validation-icon"
                data-tooltip={props.validationMessage}
              >
                <FontAwesomeIcon icon={faCircleExclamation} />
                &nbsp;
              </span>
            )}
          </div>
          <input
            type={props.type}
            onKeyDown={(e) => {
              if (props.type === "number") {
                if (e.key.length === 1 && !/[0-9.]/.test(e.key)) {
                  e.preventDefault();
                  setNumberError(true);
                }
                if (e.key === "." && e.target.value.includes(".")) {
                  e.preventDefault();
                }
              }

              if (props.type === "arabic") {
                // const arabicKey = /^[\u0600-\u06FF\s]$/;
                // For Number
                const arabicKey =
                  /^[\u0600-\u06FF\u0660-\u0669 0-9\s.,!?;:'"\-()،؟]+$/;
                if (
                  e.key.length === 1 && // filter only character keys
                  !arabicKey.test(e.key)
                ) {
                  e.preventDefault(); // block invalid key
                  setArabicError(true);
                }
              }
              if (props.type === "english") {
                // const englishKey = /^[A-Za-z\s]$/;
                //For Number
                const englishKey = /^[A-Za-z0-9\s.,!?;:'"\-()]+$/;
                if (e.key.length === 1 && !englishKey.test(e.key)) {
                  e.preventDefault();
                  setEnglishError(true);
                }
              }
              // if (props.type === "rate") {
              //   const nextValue = e.target.value + e.key;
              //   const ratePattern = /^(100|[1-9]?[0-9])$/;
              //   if (e.key.length === 1 && !ratePattern.test(nextValue)) {
              //     e.preventDefault();
              //   }
              // }
            }}
            id={JsonDataa?.JsonData[props.fieldsName]?.code}
            value={inputValue} // Use the inputValue from state
            placeholder={JsonDataa?.JsonData[props.fieldsName]?.PlaceHolder}
            onChange={handleChange}
            disabled={props.disabled}
            required={props.required}
            className={props.showValidationMessage ? "input-error" : ""}
            onBlur={props.onBlur}
            onWheel={(e) => e.target.blur()}
            dir={props.dir}
            style={props.style}
          />
          {/* {props.showValidationMessage && (
            <p className="error-message">{props.validationMessage}</p>
          )} */}
          {arabicError && (
            <p className="error-message">
              {lang == "ar"
                ? "يمكنك الكتابة باللغة العربية فقط"
                : "You can only write in Arabic"}
            </p>
          )}
          {englishError && (
            <p className="error-message">
              {lang == "ar"
                ? "يمكنك الكتابة باللغة الانجليزية فقط"
                : "You can only write in English"}
            </p>
          )}
          {numberError && (
            <p className="error-message">
              {lang == "ar"
                ? "يمكنك كتابة ارقام فقط"
                : "You can only write Numbers"}
            </p>
          )}
        </div>
      )}
    </>
  ) : (
    ""
  );
}
